import React from 'react'
import { IIconProps } from './IIconProps'

interface IProps extends IIconProps {
  className?: string
}

const IconJobFamily: React.FC<IProps> = (props) => (
  <svg
    className={props.className}
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8065 0a.3636.3636 0 0 1 .3636.3636v5.078a.3636.3636 0 0 1-.3636.3636H8.1243l-.9934.9935v3.191a.2727.2727 0 0 1-.2728.2727h-3.069l-.8711.8711v2.2188a.1818.1818 0 0 1-.1819.1818H.1818A.1818.1818 0 0 1 0 13.3523v-2.6495a.1818.1818 0 0 1 .1818-.1818h2.2023l.8547-.8548V6.5163a.2727.2727 0 0 1 .2727-.2725h3.0276l1.0088-1.0089V.3636A.3637.3637 0 0 1 7.9116 0h4.8949ZM.9091 11.2482a.1818.1818 0 0 0-.1818.1818v1.195c0 .1004.0814.1818.1818.1818h1.0998a.1818.1818 0 0 0 .1818-.1818V11.43a.1818.1818 0 0 0-.1818-.1818H.909Zm3.5115-4.0955a.2728.2728 0 0 0-.2727.2727v1.6552c0 .1506.1221.2727.2727.2727H5.949a.2727.2727 0 0 0 .2728-.2727V7.4254a.2728.2728 0 0 0-.2728-.2727H4.4206Zm4.5819-6.0618a.3637.3637 0 0 0-.3636.3637v2.896c0 .2009.1628.3637.3636.3637h2.7131a.3636.3636 0 0 0 .3636-.3636V1.4546a.3636.3636 0 0 0-.3636-.3637H9.0025Z"
      fill={props.color}
    ></path>
  </svg>
)

export default IconJobFamily
